import { useEffect, useRef } from 'react';
import { Step, STEP_NAMES } from '../calculatorSteps';
import { trackEvent } from '../../../utils/googleAnalytics';
import { EVENTS_MAP } from '../../../config/g4a/analytics-map';

export const useCalculatorAnalytics = (currentStep: number) => {
  const currentStepRef = useRef<number>(Step.Intro);

  useEffect(() => {
    currentStepRef.current = currentStep;
    trackEvent(EVENTS_MAP.CALCULATOR_STEP_VIEW, {
      step_number: currentStep,
      step_name: STEP_NAMES[currentStep] ?? 'unknown',
    });
  }, [currentStep]);

  useEffect(() => {
    return () => {
      const finalStep = currentStepRef.current;
      if (finalStep !== Step.Intro && finalStep !== Step.Success) {
        trackEvent(EVENTS_MAP.CALCULATOR_ABANDONED, {
          step_number: finalStep,
          step_name: STEP_NAMES[finalStep] ?? 'unknown',
        });
      }
    };
  }, []);
};
